export const UIConstants = {
    Date: '날짜',
    UserId : '유저 ID',
    NftUid : 'NFT UID',
    CampaignNo: "캠페인 번호",
    TransactionNo : '트랜잭션 번호',
    TransactionType : '트랜잭션 유형',
    MailNo : '우편 번호',
    SpecialBoxNo : "스페셜 박스 번호",
    WalletNo: "지갑 번호",
    CarType : '차종',
    Level : '레벨',
}